import { withAppCrashIfException } from 'epic';
import {
  documentationStreamingEpic,
  priceStreamingClosedEpic,
  priceStreamingEpic,
  priceStreamingExpiredEpic,
  priceStreamingRejectedEpic,
  tradeAuthStreamingEpic,
} from 'epic/streamingQuote/streamingQuote';
import { combineEpics } from 'redux-observable';
export const streamingQuoteEpic = () =>
  combineEpics(
    withAppCrashIfException('priceStreamingEpic', priceStreamingEpic()),
    withAppCrashIfException('tradeAuthStreamingEpic', tradeAuthStreamingEpic()),
    withAppCrashIfException('documentationStreamingEpic', documentationStreamingEpic()),
    withAppCrashIfException('priceStreamingClosedEpic', priceStreamingClosedEpic()),
    withAppCrashIfException('priceStreamingRejectedEpic', priceStreamingRejectedEpic()),
    withAppCrashIfException('priceStreamingExpiredEpic', priceStreamingExpiredEpic()),
  );
